import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';

export type MarkdownString = string;

@Component({
  selector: 'app-markdown-card',
  standalone: true,
  imports: [CommonModule, MarkdownModule],
  templateUrl: './markdown-card.component.html',
})
export class MarkdownCardComponent {
  markdownString = input<MarkdownString>();
  data = computed(() => this.markdownString() ?? '');
}
